/* eslint-disable max-len */
// 安全验证弹框配置
export default {
  checkTitle: '為了驗證您的帳號安全，請先驗證身份',
  changeTitleForPhone: '請輸入想要更換的注册手機號',
  changeTitleForEmail: '請輸入想要更換的注册郵箱',
  bindTitleForPhone: '請輸入想要綁定的注册手機號',
  bindTitleForEmail: '請輸入想要綁定的注册郵箱',
};
